// Fragment "email unsubscribe" — the marketing-footer link's landing page
// (public/EmailUnsubscribe.jsx, `/public/email/unsubscribe?t=`). Contract C2.06:
// transactional mail (session reminders) never carries this link and is unaffected by
// it. Merged in ./index.js.
export default {
  fr: {
    "unsub.eyebrow": "Préférences d'e-mail",
    "unsub.title": "Se désabonner des e-mails marketing",
    "unsub.body": "Vous ne recevrez plus d'e-mails promotionnels de ce cabinet. Les e-mails liés à vos rendez-vous (rappels, confirmations) continueront d'être envoyés.",
    "unsub.button": "Se désabonner",
    "unsub.doneTitle": "Vous êtes désabonné·e",
    "unsub.doneBody": "Vous ne recevrez plus d'e-mails marketing de ce cabinet.",
    "unsub.missingTokenTitle": "Lien incomplet",
    "unsub.missingTokenBody": "Ce lien ne comporte pas les informations nécessaires.",
    "unsub.unknownTokenTitle": "Lien introuvable",
    "unsub.unknownTokenBody": "Ce lien n'est plus valable. Si vous continuez de recevoir des e-mails indésirables, contactez le cabinet.",
  },
  en: {
    "unsub.eyebrow": "Email preferences",
    "unsub.title": "Unsubscribe from marketing emails",
    "unsub.body": "You'll stop receiving promotional emails from this practice. Appointment-related emails (reminders, confirmations) will keep arriving.",
    "unsub.button": "Unsubscribe",
    "unsub.doneTitle": "You're unsubscribed",
    "unsub.doneBody": "You will no longer receive marketing emails from this practice.",
    "unsub.missingTokenTitle": "Incomplete link",
    "unsub.missingTokenBody": "This link is missing the information it needs.",
    "unsub.unknownTokenTitle": "Link not found",
    "unsub.unknownTokenBody": "This link is no longer valid. If you keep receiving unwanted emails, contact the practice.",
  },
  es: {
    "unsub.eyebrow": "Preferencias de correo",
    "unsub.title": "Darse de baja de los correos de marketing",
    "unsub.body": "Dejarás de recibir correos promocionales de esta consulta. Los correos relacionados con tus citas (recordatorios, confirmaciones) seguirán llegando.",
    "unsub.button": "Darse de baja",
    "unsub.doneTitle": "Te has dado de baja",
    "unsub.doneBody": "Ya no recibirás correos de marketing de esta consulta.",
    "unsub.missingTokenTitle": "Enlace incompleto",
    "unsub.missingTokenBody": "A este enlace le falta la información necesaria.",
    "unsub.unknownTokenTitle": "Enlace no encontrado",
    "unsub.unknownTokenBody": "Este enlace ya no es válido. Si sigues recibiendo correos no deseados, contacta con la consulta.",
  },
};
